import { invokeFlutterService } from '@/utils/flutter/flutter-service';
import { IAPMockedProducts, IAPproductConfig } from '@/utils/iap';
import { semaphore, commands } from '../flutter/flutter2-semaphore';

const IAPuseMockedProducts = () => {
    return;
    window.fireFlutterEvent('flutter:getOfferings', JSON.stringify(IAPMockedProducts));
}

const IAPgetOfferings = (forced = false) => {
    try {
        if (!forced && window.IAP.status.includes('offeringsLoaded')) return;

        if ('SemaphoreJavascriptChannel' in window) {
            semaphore({
                name: commands.iap.command,
                data: {
                  value: commands.iap.getOfferings
                },
              })
        } else {
            invokeFlutterService('FlutterGetOfferingsService','');
        }
        window.IAP.status.push('offeringsRequested');

        if (process.env.NODE_ENV === 'development' || location.hostname === 'localhost') {
             window.setTimeout(()=> {
                 IAPuseMockedProducts();
             }, 250);
        }
    }
    catch (error) {
        window.captureException(error);
    }
}

/** @type {(flutterData: Record<'offerings', Array<Product>>) => never | void} */
const IAPupdateOfferings = (flutterData) => {
    try {
        const { offerings } = flutterData;

        if (!offerings) throw new Error('No offering found!');

        const cfg = IAPproductConfig();

        /**
         * 1. Get the `Debug info` modal,
         * 2. Check `tester` property value is 1,
         * 3. Restart application,
         * 4. Go to subscriptions,
         * 5. Subscribe to `test` product.
         *
         * By default products are only visible, if product id in `IAPproductConfig`.
         */
        if (localStorage.getItem('isTester') !== null && localStorage.getItem('isTester') === '1') {
            // @ts-ignore
            cfg.test = {
                test: {
                    title: 'Test',
                    desc: 'Test',
                    icon: 'SvgEmail',
                }
            };
        }

        offerings.forEach((product) => {
            if (!Object.keys(cfg).includes(product.id)) return;
            if (cfg.hasOwnProperty(product.id)) {
                // @TODO: filter by packageName
                Object.assign(product, cfg[product.id]);

                window.IAP.products[product.id] = product;
            }
        });

        window.IAP.status.push('offeringsLoaded');
    }
    catch (error) {
        window.captureException(error);
    }
}

export { IAPgetOfferings, IAPupdateOfferings };
